class Modal extends HTMLElement {
  connectedCallback () {
    this.render()
  }

  render () {
    this.innerHTML = `
    <div class="modal">
      <div class="fas fa-times hide"></div>
      <div class="modal__body">
        <div class="title">Review Restaurant</div>
        <div class="form">
          <input type="text" placeholder="Your Full Name" name="" id="fullName">
          <textarea placeholder="Your Review" name="" rows="10" id="customerReview"></textarea>
          <button class="btn">Submit</button>
        </div>
      </div>
    </div>`
  }
}

customElements.define('app-modal', Modal)
